module.exports = __webpack_public_path__ + "img/43.d1622eaa.jpg";